import React from 'react';
import { Checkbox as AntdCheckbox } from 'antd';
import style from './Checkbox.module.scss';

interface IProps {
	children: React.ReactNode;
	checked: boolean;
	disabled?: boolean;
	testId?: string;
	onChange: () => void;
}

export const Checkbox: React.FC<IProps> = React.memo(({ children, checked, disabled = false, testId, onChange }) => (
	<AntdCheckbox
		className={style.container}
		checked={checked}
		disabled={disabled}
		onChange={onChange}
		data-test={testId}>
		{children}
	</AntdCheckbox>
));
